const Permissions = {
  // Administrador de la plataforma
  'Root': {
    'Business': ['list', 'show', 'create', 'edit', 'delete'],
    'Users': ['list', 'show', 'create', 'edit', 'delete'],
    'Branches': ['list', 'show', 'create', 'edit', 'delete'],
    'Terminals': ['list', 'show', 'create', 'edit', 'delete'],
    'Products': ['list', 'show', 'create', 'edit', 'delete'],
    'Categories': ['list', 'show', 'create', 'edit', 'delete'],
    'Orders': ['list'],
    'Transactions': ['list'],
    'CustomReport': ['list'],
    'CloseReports': ['list'],
    'SoldProducts': ['list'],
    'Settings': ['list'],
    'Dashboard': ['list'],
    'Processors': ['list'],
    'Features': ['list'],
    'PaymentMethods': ['list'],
    'Banks': ['list'],
    'Credentials': ['list'],
    'ProductBatch': ['list'],
    'ProductStock': ['list'],
    'Services': ['list', 'show', 'create', 'edit', 'delete']
  },
  // Administrador de un business (Comercio) (Consultas by business)
  'Admin': {
    'Users': ['list', 'show', 'create', 'edit', 'delete'],
    'Branches': ['list', 'show', 'create', 'edit', 'delete'],
    'Terminals': ['list', 'show', 'create', 'edit', 'delete'],
    'Products': ['list', 'show', 'create', 'edit', 'delete'],
    'Categories': ['list', 'show', 'create', 'edit', 'delete'],
    'Orders': ['list'],
    'Transactions': ['list'],
    'CustomReport': ['list'],
    'CloseReports': ['list'],
    'SoldProducts': ['list'],
    'Settings': ['list'],
    'Dashboard': ['list'],
    'ProductBatch': ['list'],
    'ProductStock': ['list'],
  },
  // Supervisor de un branch (Sucursal) (Consultas by branch)
  'Supervisor': {
    'Users': ['list', 'show', 'create', 'edit', 'delete'],
    'Terminals': ['list', 'show', 'create', 'edit', 'delete'],
    'Products': ['list', 'show', 'create', 'edit', 'delete'],
    'Categories': ['list', 'show', 'create', 'edit', 'delete'],
    'Orders': ['list'],
    'Transactions': ['list'],
    'CustomReport': ['list'],
    'CloseReports': ['list'],
    'SoldProducts': ['list'],
    'Settings': ['list'],
    'Dashboard': ['list'],
  },
  // Cajero
  'Teller': {
    'Transactions': ['list'],
  },
}

export default Permissions;